function clickComponent(type) {
  const components = document.querySelectorAll(".component__item");

  components.forEach((component) => {
    component.addEventListener("click", (e) => {
      const type = e.currentTarget.getAttribute("data-type");
      e.currentTarget.children[1].classList.toggle("tw-block");
      e.currentTarget.children[1].classList.toggle("tw-hidden");

      const openIcon = document.querySelector(`[data-iconType="${ type }"]`)
      const iconText = openIcon.innerText
      openIcon.innerText = iconText === 'add' ? 'remove' : 'add'
    })
  })
}

clickComponent()